import BScroll from '@better-scroll/core';
import MouseWheel from '@better-scroll/mouse-wheel';
import PullDown from '@better-scroll/pull-down';
import moment from 'moment';
import { lazy, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.scss';
import { ProtectedRoute } from './ProtectedRoute';
import { EnterCountProvider } from './contexts/EnterCountContext';
import { EnterGameProvider } from './contexts/EnterGameContext';
import { GaContextProvider } from './contexts/GaContext';
import { GameInfoButtonControllerProvider } from './contexts/GameInfoButtonControllerContext';
import { SettingMenuProvider } from './contexts/SettingMenuContext';
import { useIframeMessage } from './hooks/useIframeMessage';
import { useLogin } from './hooks/useLogin';
import { useMaxWidth } from './hooks/useMaxWidth';
import { useStartTime } from './hooks/useStartTime';
import { LVT_KEY, useVersion } from './hooks/useVersion';
import {
    ROUTE_FAVORITE,
    ROUTE_FEATURED,
    ROUTE_GAME,
    ROUTE_LOBBY,
    ROUTE_MULTIBET,
    ROUTE_RELOAD,
    ROUTE_ROOT,
    ROUTE_THANKS4PLAY,
} from './models/Route';
import { useAnalytic } from './modules/analytic/hook';
import { Landing } from './modules/landing';
import { LobbyLayout } from './modules/lobby/components/Layout';
import { Lobbyw } from './modules/lobbyw';
import { Popup } from './modules/popup';
import { NoticePopup } from './modules/popup/notice/NoticePopup';
import { PayoutPopup } from './modules/popup/payout';
import { MemoizedPromotionPopup } from './modules/popup/promotiontool/components/PromotionPopup';
import { ReconnectLayer } from './modules/reconnectLayer';
import { RouteController } from './modules/routeController';
// const PromotionDialog = lazy(() =>
//     import('./modules/popup/promotiontool/components/PromotionDialog').then(
//         ({ PromotionDialog }) => ({
//             default: PromotionDialog,
//         })
//     )
// );
// const GameScene = lazy(() =>
//     import('./modules/game').then(({ GameScene }) => ({
//         default: GameScene,
//     }))
// );
const RwdGameScene = lazy(() =>
    import('./modules/rwdGame').then(({ RwdGameScene }) => ({
        default: RwdGameScene,
    }))
);
const ThanksForPlaying = lazy(() =>
    import('./modules/thanksForPlaying').then(({ ThanksForPlaying }) => ({
        default: ThanksForPlaying,
    }))
);
const Lobby = lazy(() =>
    import('./modules/lobby').then(({ Lobby }) => ({
        default: Lobby,
    }))
);
const Featured = lazy(() =>
    import('./modules/featured').then(({ FeaturedGames }) => ({
        default: FeaturedGames,
    }))
);
const MultiBetScene = lazy(() =>
    import('./modules/multibetRevamp').then(({ MultiBet }) => ({
        default: MultiBet,
    }))
);
const Favorite = lazy(() =>
    import('./modules/favorite').then(({ Favorite }) => ({
        default: Favorite,
    }))
);
const RunHook = () => {
    useStartTime();
    useLogin();
    useVersion();
    useIframeMessage();
    useAnalytic();
    useMaxWidth();
    return <></>;
};
const App = () => {
    const { i18n } = useTranslation();
    // For Right to Left layout (e.g.Arabic)
    useEffect(() => {
        // document.body.dir = i18n.dir();
        document.documentElement.style.setProperty(
            '--text-direction',
            `${i18n.dir()}`
        );
    }, [i18n, i18n.language]);
    useEffect(() => {
        const current = moment().valueOf().toString();
        window.localStorage.setItem(LVT_KEY, current);

        BScroll.use(MouseWheel);
        BScroll.use(PullDown);
    }, []);

    return (
        <>
            <EnterCountProvider>
                <BrowserRouter>
                    <EnterGameProvider>
                        <SettingMenuProvider>
                            <GaContextProvider>
                                <GameInfoButtonControllerProvider>
                                    <Routes>
                                        <Route
                                            index
                                            path={ROUTE_ROOT}
                                            element={<Landing />}
                                        />
                                        <Route
                                            path={ROUTE_THANKS4PLAY}
                                            element={<ThanksForPlaying />}
                                        />
                                        <Route element={<LobbyLayout />}>
                                            <Route
                                                path={ROUTE_LOBBY}
                                                element={<Lobby />}
                                            />
                                            <Route
                                                path={ROUTE_FEATURED}
                                                element={<Featured />}
                                            />
                                            <Route
                                                path={ROUTE_FAVORITE}
                                                element={<Favorite />}
                                            />
                                        </Route>

                                        <Route
                                            path={ROUTE_GAME + '/:hostId'}
                                            element={
                                                <ProtectedRoute>
                                                    <RwdGameScene />
                                                    {/* <GameScene /> */}
                                                </ProtectedRoute>
                                            }
                                        />
                                        <Route
                                            path={ROUTE_MULTIBET}
                                            element={<MultiBetScene />}
                                        />
                                        <Route
                                            path={ROUTE_RELOAD}
                                            element={
                                                <ProtectedRoute>
                                                    <Lobbyw />
                                                </ProtectedRoute>
                                            }
                                        />
                                    </Routes>
                                    <NoticePopup />
                                    <MemoizedPromotionPopup />
                                    <PayoutPopup />
                                    <Popup />
                                    {/* <NewUIPopup /> */}
                                    <RouteController />
                                    <ReconnectLayer />
                                </GameInfoButtonControllerProvider>
                            </GaContextProvider>
                        </SettingMenuProvider>
                    </EnterGameProvider>
                </BrowserRouter>
            </EnterCountProvider>
            <RunHook />
        </>
    );
};

export default App;
